import { Box, Divider, Typography } from '@mui/material';
import { useAppSelector } from '../../../../../../../../store/hooks';
import zeplinColor from '../../../../../../../../theme/Color';
import styles from './HistoryRecord.module.css';

export const HistoryRecord = () => {
  const selectedRole = useAppSelector((state) => state.rolesAndPermissions.selectedRole)!;

  return (
    <Box className={styles['timeline-items']}>
      {selectedRole.history.map(({ userName, profilePicture, date, action }) => {
        return (
          <Box
            className={styles['timeline-item']}
            sx={{
              position: 'relative',
              backgroundColor: zeplinColor.Neutral3,
              padding: '16px',
              borderRadius: '14px',
              transform: 'translateY(-20px)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                marginBottom: '12px',
              }}
            >
              <Typography variant='body3'>{date}</Typography>
              <Divider orientation='vertical' flexItem sx={{ color: zeplinColor.BasicBlack }} />
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box
                  sx={{
                    display: 'flex',
                    marginRight: '8px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                  }}
                >
                  <img src={profilePicture} alt='Profile' width={'100%'} height={'100%'} />
                </Box>
                {userName}
              </Box>
            </Box>
            <Typography>{action}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};
